import { GetAuthToken } from '@domain/auth/AuthContext';

import { returnJsonOrThrow, JSON_HEADERS, post } from './shared';

export enum PremiumPurchaseStatus {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE',
}
export interface ICreatePremiumResponse {
  status: PremiumPurchaseStatus;
  paymentIntentSecret?: string;
  setupIntentSecret?: string;
}

export const createPremium = async (
  getAuthToken: GetAuthToken,
  token: string | null,
  planId: string,
  code?: string,
): Promise<ICreatePremiumResponse> => {
  const body = {
    data: {
      token,
      coupon_code: code,
    },
    plan_id: planId,
    type: 'stripe',
  };
  return post('/me/web_subscriptions', getAuthToken, false, body, JSON_HEADERS).then(
    async response => {
      const { payment_intent_secret: paymentIntentSecret, setup_intent_secret: setupIntentSecret } =
        await returnJsonOrThrow<{
          payment_intent_secret?: string;
          setup_intent_secret?: string;
        }>(response);

      if (paymentIntentSecret) {
        return { status: PremiumPurchaseStatus.Incomplete, paymentIntentSecret };
      }

      return { status: PremiumPurchaseStatus.Complete, setupIntentSecret };
    },
  );
};
